<template>
	<div :style="{color:jisuan}">
		{{num}}
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		computed: {
			jisuan() {
				if(!this.color){
					return 'black';
				}
				if (this.num == 0) {
					return "green";
				};
				if (this.num > 0 & this.warn) {
					return "red";
				} else {
					return "orange";
				}
			}
		},
		props: ["num", "warn","color"],
		created() {

		}
	}
</script>

<style>
</style>
